import { render } from "./criteria-assessment.vue?vue&type=template&id=080ef344&scoped=true&ts=true"
import script from "./criteria-assessment.vue?vue&type=script&lang=ts"
export * from "./criteria-assessment.vue?vue&type=script&lang=ts"

import "./criteria-assessment.vue?vue&type=style&index=0&id=080ef344&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080ef344"]])

export default __exports__